import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { registerWebPush, unregisterWebPush } from '../utils/push';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [company, setCompany] = useState(() => {
    try { return JSON.parse(localStorage.getItem('company')); } catch { return null; }
  });

  const login = useCallback((data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('company', JSON.stringify(data.company));
    setUser(data.user);
    setCompany(data.company);
  }, []);

  const logout = useCallback(() => {
    // Best-effort: stop this browser receiving push for the user we're logging out.
    unregisterWebPush();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('company');
    setUser(null);
    setCompany(null);
  }, []);

  // Subscribe this browser to Web Push whenever a user is signed in (idempotent).
  useEffect(() => {
    if (user) registerWebPush();
  }, [user]);

  const updateCompany = useCallback((updatedCompany) => {
    localStorage.setItem('company', JSON.stringify(updatedCompany));
    setCompany(updatedCompany);
  }, []);

  const updateUser = useCallback((updatedUser) => {
    localStorage.setItem('user', JSON.stringify(updatedUser));
    setUser(updatedUser);
  }, []);

  const canEdit = user?.role === 'Owner' || user?.role === 'Manager' || user?.role === 'Editor';
  const canManage = user?.role === 'Owner' || user?.role === 'Manager';
  const isOwner = user?.role === 'Owner';
  const isAdmin = user?.isPlatformAdmin === true;

  return (
    <AuthContext.Provider value={{ user, company, login, logout, updateCompany, updateUser, canEdit, canManage, isOwner, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
